var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pwa-nav-left"},[_c('BurgerToggle',{on:{"handleClick":_vm.openBurgerMenu}}),_c('img',{staticClass:"sai-logo",attrs:{"src":"/common/skin/i2i/img/logo.png","alt":"Intertek Inform"}}),_c('PwaOverLayMenuLeft')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }